/**
 * Common constants and strings used across the application
 */

// Error Messages
export const TRANSIENT_FAILURE_MESSAGE = 'Something went wrong, please try again later.';
